import { Box } from '@mantine/core';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export const IconBox = ({ children, className }: Props) => (
  <Box
    className={className}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 24,
      height: 24,
    }}
  >
    {children}
  </Box>
);
